import { isSet } from "../utils/isSet";

export const setupLazyPlayVideo = (emblaApi) => {
    const slideNodes = emblaApi.slideNodes();
    const videoNodes = slideNodes.map((slideNode) =>
        slideNode.querySelector('.herschel-video--js')
    );

    const playVideoNode = (node) => {
        if(!isSet(node)) return;
        const videoElm = node.querySelector('.herschel-video--js .video__target');
        if(isSet(videoElm)) videoElm.play();
    }

    const pauseVideoNode = (node) => {
        if(!isSet(node)) return;
        const videoElm = node.querySelector('.herschel-video--js .video__target');
        if(isSet(videoElm)) videoElm.pause();
    }

    const loadImagesInViewAndDestroyIfDone = (emblaApi, eventName) => {
        const slidesInView = emblaApi.slidesInView(true);
        const slidesNotInView = emblaApi.slidesNotInView(true);

        videoNodes.filter((node, index, videoNodesArr) => slidesInView.includes(index)).forEach(playVideoNode);
        videoNodes.filter((node, index, videoNodesArr) => slidesNotInView.includes(index)).forEach(pauseVideoNode);
    }

    return loadImagesInViewAndDestroyIfDone
}
  